// firebase.js
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/messaging';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
    apiKey: "AIzaSyCiPLE9JfzKG-_YHhOYOn3w9EO-dqyudDo",
    authDomain: "hcgroup40.firebaseapp.com",
    projectId: "hcgroup40",
    storageBucket: "hcgroup40.appspot.com",
    messagingSenderId: "360905378090",
    appId: "1:360905378090:web:e65b97087b55724567b653",
    measurementId: "G-7L3DR7ZNYQ"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export { firebase, firebaseConfig }; // export firebase and firebaseConfig